import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
  name: 'get',
  standalone: true,
})
export class GetPipe implements PipeTransform {
  public transform(object: unknown, path: string, defaultValue?: unknown): any {
    return get(object, path, defaultValue);
  }
}
